/** Brief window after sign-in where a failed refresh must not force logout (mobile race / cookie lag). */
const LOGIN_GRACE_MS = 20_000;

let loginGraceUntil = 0;

export function markLoginGracePeriod(): void {
  loginGraceUntil = Date.now() + LOGIN_GRACE_MS;
}

export function clearLoginGracePeriod(): void {
  loginGraceUntil = 0;
}

export function isInLoginGracePeriod(): boolean {
  return Date.now() < loginGraceUntil;
}
